import React from 'react';
import { IHocSinh } from '../../../models/response/crm-hocsinh/IHocsinh';
import { Controller, UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import FormBlock from './FormBlock';
import { Box, FormControl } from '@primer/react';
import { ComboboxTruong } from '../../../components/combobox-truong';
import ComboboxKhoi from '../../../components/combobox-khoi';
import ComboboxHe from '../../../components/combobox-he';

interface IThongTinDangKyProps {
    control: any,
    hocSinh: IHocSinh,
    setFormData: React.Dispatch<React.SetStateAction<IHocSinh>>,
    setValue: UseFormSetValue<IHocSinh>,
    register: any,
    errors: any,
    formData: IHocSinh,
    trigger: UseFormTrigger<IHocSinh>
}

const errorComboSx = {
    "& button": {
        borderColor: "danger.emphasis !important",
        boxShadow: "0 0 0 1px #cf222e",
    },
};

const requiredStar = <Box as="span" sx={{ color: "danger.fg" }}> *</Box>;

const ThongTinDangKy = (props: IThongTinDangKyProps) => {
    const { control, setFormData, setValue, errors, formData } = props;

    const handleTruongChange = (value: number) => {
        setFormData((prev) => ({
            ...prev,
            dm_truong_id: value,
            dm_khoi_id: 0,
            dm_he_id: 0,
            dm_lop_id: 0,
        }));
        setValue("dm_khoi_id", 0);
        setValue("dm_he_id", 0);
        setValue("dm_lop_id", 0);
    };

    const handleKhoiChange = (value: number) => {
        setFormData((prev) => ({
            ...prev,
            dm_khoi_id: value,
            dm_he_id: 0,
            dm_lop_id: 0,
        }));
        setValue("dm_he_id", 0);
        setValue("dm_lop_id", 0);
    };

    return (
        <FormBlock caption="Thông tin đăng ký">
            <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "repeat(4, 1fr)" }}>
                <Controller
                    name="dm_truong_id"
                    control={control}
                    rules={{
                        required: "Vui lòng chọn cấp học",
                        validate: (v: any) => Number(v) > 0 || "Vui lòng chọn cấp học",
                    }}
                    render={({ field }) => (
                        <FormControl>
                            <FormControl.Label>Chọn cấp học{requiredStar}</FormControl.Label>
                            <Box sx={errors.dm_truong_id ? errorComboSx : undefined}>
                                <ComboboxTruong
                                    value={field.value}
                                    onValueChanged={(value) => {
                                        field.onChange(value);
                                        handleTruongChange(value);
                                    }}
                                />
                            </Box>
                            {errors.dm_truong_id && (
                                <FormControl.Validation variant="error">
                                    {errors.dm_truong_id.message}
                                </FormControl.Validation>
                            )}
                        </FormControl>
                    )}
                />

                <Controller
                    name="dm_khoi_id"
                    control={control}
                    rules={{
                        required: "Vui lòng chọn khối",
                        validate: (v: any) => Number(v) > 0 || "Vui lòng chọn khối",
                    }}
                    render={({ field }) => (
                        <FormControl>
                            <FormControl.Label>Chọn khối{requiredStar}</FormControl.Label>
                            <Box sx={errors.dm_khoi_id ? errorComboSx : undefined}>
                                <ComboboxKhoi
                                    dm_truong_id={formData.dm_truong_id}
                                    value={field.value}
                                    onValueChanged={(value) => {
                                        field.onChange(value);
                                        handleKhoiChange(value);
                                    }}
                                />
                            </Box>
                            {errors.dm_khoi_id && (
                                <FormControl.Validation variant="error">
                                    {errors.dm_khoi_id.message}
                                </FormControl.Validation>
                            )}
                        </FormControl>
                    )}
                />

                <Controller
                    name="dm_he_id"
                    control={control}
                    rules={{
                        required: "Vui lòng chọn hệ",
                        validate: (v: any) => Number(v) > 0 || "Vui lòng chọn hệ",
                    }}
                    render={({ field }) => (
                        <FormControl>
                            <FormControl.Label>Chọn hệ{requiredStar}</FormControl.Label>
                            <Box sx={errors.dm_he_id ? errorComboSx : undefined}>
                                <ComboboxHe
                                    value={field.value}
                                    dm_khoi_id={formData.dm_khoi_id}
                                    dm_truong_id={formData.dm_truong_id}
                                    onValueChanged={(value) => {
                                        field.onChange(value);
                                        setFormData((prev) => ({
                                            ...prev,
                                            dm_he_id: value,
                                        }));
                                    }}
                                />
                            </Box>
                            {errors.dm_he_id && (
                                <FormControl.Validation variant="error">
                                    {errors.dm_he_id.message}
                                </FormControl.Validation>
                            )}
                        </FormControl>
                    )}
                />
            </Box>
        </FormBlock>
    );
};

export default ThongTinDangKy;
